import { create } from "zustand"

export const useStudentsTagsModalStore = create((set, get) => ({
    disclosure: null,
    setDisclosure: (newDisclosure) => set({ disclosure: newDisclosure }),

    student: null,
    setStudent: (newStudent) => set({ student: newStudent }),

    purchase: null,
    setPurchase: (newPurchase) => set({ purchase: newPurchase }),

    isProlongations: false,
    setIsProlongations: (newIsprolongations) => set({ isProlongations: newIsprolongations }),
}))

export const useConfirmationModalStore = create((set, get) => ({
    disclosure: null,
    setDisclosure: (disclosure) => set({ disclosure: disclosure }),

    state: {
        title: "",
        question: "",
        btnText: "",
        func: null,
        args: [],
    },
    setState: (state) => set({ state: state }),
}))

export const useAdminContextModalStore = create((set, get) => ({
    modalUser: null,
    setModalUser: (user) => set({ modalUser: user }),
}))

export const useProlongationFilesModalStore = create((set, get) => ({
    isEdit: false,
    setIsEdit: (isEdit) => set({ isEdit: isEdit }),

    state: {
        date: '',
        title: '',
        file: null
    },
    setState: (state) => set({ state: state }),
}))

export const useChangeContextModalStore = create((set, get) => ({
    disclosure: null,
    setDisclosure: (disclosure) => set({ disclosure: disclosure }),

    contexts: null,
    setContexts: (contexts) => set({ contexts: contexts }),
}))

export const useProlongationDetailModalStore = create((set, get) => ({
    disclosure: null,
    setDisclosure: (disclosure) => set({ disclosure: disclosure }),

    prolongation: null,
    setProlongation: (prolongation) => set({ prolongation: prolongation }),
}))
